module.exports = __webpack_public_path__ + "static/media/login-trn.19d88062.jpeg";